import { useEffect, useState } from "react";
import { guestOpacApi, type GuestOpacResourceSummary } from "@/lib/api/guest-opac";
import { GuestCatalogSectionCard } from "@/components/guest-catalog/GuestCatalogSectionCard";
import { GuestCatalogSectionHeader } from "@/components/guest-catalog/GuestCatalogSectionHeader";
import { GuestCatalogItemView } from "@/components/guest-catalog/GuestCatalogItemView";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";

interface GuestCatalogRelatedProps {
  tenantSlug: string;
  excludePublicId: string;
  searchTerm?: string;
  viewMode?: GuestCatalogViewMode;
}

export function GuestCatalogRelated({
  tenantSlug,
  excludePublicId,
  searchTerm,
  viewMode = "grid",
}: GuestCatalogRelatedProps) {
  const [items, setItems] = useState<GuestOpacResourceSummary[]>([]);

  useEffect(() => {
    if (!searchTerm?.trim()) {
      setItems([]);
      return;
    }
    let cancelled = false;
    guestOpacApi
      .search({ q: searchTerm.trim(), type: "all", page: 1, pageSize: 8 }, tenantSlug)
      .then((res) => {
        if (cancelled) return;
        setItems(res.items.filter((i) => i.publicId !== excludePublicId).slice(0, 6));
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantSlug, excludePublicId, searchTerm]);

  if (items.length < 2) return null;

  return (
    <GuestCatalogSectionCard>
      <section className="space-y-4">
        <GuestCatalogSectionHeader title="You might also like" />
        <GuestCatalogItemView items={items} viewMode={viewMode} tenantSlug={tenantSlug} />
      </section>
    </GuestCatalogSectionCard>
  );
}
